import { ApiService } from './../../../service/core/api.service';
import { UploadOutput, UploadInput, UploadFile, humanizeBytes } from 'ngx-uploader';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { DialogService } from 'ng2-bootstrap-modal';
import { ExcelModalComponent } from '../../modal/excel.modal';
import { FormBaseComponent } from 'app/form/core/component/form-base/form-base.component';
import { FormControl } from '@angular/forms';
import swal from 'sweetalert2';
import { loadingService } from 'app/core/service/loading.service';



@Component({
  selector: 'excel-edo',
  templateUrl: './excel-edo.component.html',
  styleUrls: ['./excel-edo.component.scss']
})
export class ExcelEdoComponent
extends FormBaseComponent<any>
implements OnInit {

  @Input() idTpv;
  @Input() UserID;
  @Input() group = 'none';
  @Input() idWizard: '0';

  formData: FormData;
  files: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  humanizeBytes: Function;
  dragOver: boolean;
  fileIcon = '';
  fileStatus = '';
  config;

  @Output()
  onComplete = new EventEmitter<any>();

  constructor(
      private apiService: ApiService,
      private dialogService: DialogService,
      private loadingService: loadingService
    ) {
    super();
    this.config = this.apiService.config
    this.files = []; // local uploading files array
    this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader
    this.humanizeBytes = humanizeBytes;
  }

  ngOnInit() 
  {
    this.init(true);
  }


  onUploadOutput(output: UploadOutput): void {
    if (output.file) {
      const type = output.file.type.length > 0 ? output.file.type.split('/')[1] : 'default';
      //console.log(type);

      switch (type) {
        case 'pdf':
          this.fileIcon = 'file-pdf-o';
          break;
        case 'doc':
        case 'docx':
          this.fileIcon = 'file-word-o';
          break;
        case 'jpeg':
        case 'jpg':
        case 'png':
          this.fileIcon = 'file-image-o';
          break;
        default:
          this.fileIcon = 'file';
          break;
      }
    }
    if (output.type == 'uploading') {
      this.loadingService.showLoading();
      this.fileStatus = 'loading'
    }
    if (output.type == 'done') {
      this.loadingService.closeLoading();
      this.fileStatus = 'done'
      //console.log(output.file);
      var suma = 0;
      if(output.file.response.object != undefined)
      {
        output.file.response.object.forEach(item => {
          suma += item.abono;
        });
        this.form.patchValue({ transaccions : output.file.response.object }  );
        this.onComplete.emit({ lista: output.file.response.object, suma: Math.round(suma) });
        swal({ title: "Proceso Completo", text: "El archivo fue procesado exitosamente", type: "success" });
      }
      else
      {
        this.fileStatus = 'error';
        this.onComplete.emit({ lista: [], suma: 0 })
        swal({ title: "Proceso incompleto", text: "Favor de verificar el formato del archivo", type: "error" });
      }
    }
    if (output.type === 'allAddedToQueue') { // when all files added in queue
      // uncomment this if you want to auto upload files when added
      const event: UploadInput = {
        type: 'uploadAll',
        url: this.config.url + 'file/readexcel',
        method: 'POST',
        data: { type: 'Trash', group: 'none', idTpv:  this.idTpv, idWizard : this.idWizard },
        concurrency: 0
      };
      this.uploadInput.emit(event);
    } else if (output.type === 'addedToQueue') {
      if(output.file != null && output.file != undefined)
      {
        this.files.push(output.file); // add file to array when added
      }
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: UploadFile) => file !== output.file);
    } else if (output.type === 'dragOver') { // drag over event
      this.dragOver = true;
    } else if (output.type === 'dragOut') { // drag out event
      this.dragOver = false;
    } else if (output.type === 'drop') { // on drop event
      this.dragOver = false;
    }
  }

  verformato(){
    this.dialogService.addDialog(ExcelModalComponent, {}, {backdropColor: 'rgba(100, 100, 100, 0.5)'}).subscribe(x => {
      //console.log('cerrado');
    })
  }

  ver()
  {
    var x = this.form.value.transaccions;
  }

  template() {
    this.form.addControl('transaccions', new FormControl('', []));
  }

}



// WEBPACK FOOTER //
// ./src/app/core/component/ui/excel-edo/excel-edo.component.ts